import {ChildEntity} from "typeorm";
import {Competition} from ".";

@ChildEntity()
export class LeagueCompetition extends Competition {
}
